import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import dictionariesReduces from './dictionaries/slice';
import chartCategoriesReducer from '../hoc/charts/store/slices/categories';
import chartAccountsReducer from '../hoc/charts/store/slices/primary-accounts';
import chartGroupsReducer from '../hoc/charts/store/slices/groups';
import statementsListReducer from '../hoc/statements/store/slices/list';
import accountsListReducer from '../hoc/accounts/store/slice';
import generalTransactionReducer from '../hoc/statements/store/slices/gl-transaction';
import externalAccountsReducer from '../hoc/external/store/slice';

export const accountsApi = api;

export const accountsReducers = {
  accountsApi: api.reducer,
  accountsDictionaries: dictionariesReduces,
  charts: combineReducers({
    categories: chartCategoriesReducer,
    groups: chartGroupsReducer,
    accounts: chartAccountsReducer,
  }),
  accountsStatements: combineReducers({
    list: statementsListReducer,
    transactions: combineReducers({
      gl: generalTransactionReducer,
    }),
  }),
  accounts: accountsListReducer,
  externalAccounts: externalAccountsReducer,
};
